import {authenticationService} from "../services";

export function handleResponse(response) {
    if (response === undefined) {
        return Promise.reject()
    }
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok && response.status !== 204) {
            if ([401, 403].indexOf(response.status) !== -1) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                authenticationService.logout();
            }
            const error = (data && data.Message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
